import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NumberOnly } from '../../../directives/number-only';
import { Auth } from '../../../services/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { Logo } from '../../../components/logo/logo';
import { ThemeService, ThemeMode } from '../../../services/theme.service';
import { ServersSessionsService } from '../../../services/servers-sessions.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-valida-email',
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    CommonModule,
    NumberOnly,
    Logo,
    TranslatePipe
  ],
  templateUrl: './valida-email.html',
  styleUrl: './valida-email.css'
})
export class ValidaEmail implements OnInit, OnDestroy {

  private _activivatedRoute = inject(ActivatedRoute);
  private _themeService = inject(ThemeService);
  private _originalTheme: ThemeMode = 'system';

  ngOnInit(): void {
    // Store original theme and force light theme
    this._originalTheme = this._themeService.themeMode();
    this._themeService.setTheme('light');

    this.formGroupEmail.get('email')?.setValue(this._activivatedRoute.snapshot.queryParams['email']);
  }

  ngOnDestroy() {
    // Restore original theme when leaving the page
    this._themeService.setTheme(this._originalTheme);
  }

  _sessions_service = inject(ServersSessionsService);
  _auth = inject(Auth);
  emailEnviado: boolean = false;
  emailValido: boolean = false;
  _router = inject(Router);
  loading = false;
  oldEmail = localStorage.getItem('oldEmail');


  formGroupEmail = new FormGroup({

    email: new FormControl(this.oldEmail, [Validators.required, Validators.email]),
  })

  formGroupCode = new FormGroup({

    code1: new FormControl('', [Validators.pattern(/^\d+$/)]),
    code2: new FormControl('', [Validators.pattern(/^\d+$/)]),
    code3: new FormControl('', [Validators.pattern(/^\d+$/)]),
    code4: new FormControl('', [Validators.pattern(/^\d+$/)]),
  })

  enviarEmail() {

    this.loading = true;
    this.formGroupEmail.setErrors(null);

    if(this.emailEnviado){
      console.log('Email já enviado');
    }

    if( this.formGroupEmail.valid && this.formGroupEmail.value.email) {

        this.loading = false;
        this.enviaEmailDeConfirmacao(this.formGroupEmail.value.email);
    }
  }

  private enviaEmailDeConfirmacao(email: string) {

    if(localStorage.getItem('abilities')?.includes('resetSenha') || localStorage.getItem('abilities') === null || localStorage.getItem('abilities') === '') {

      this.enviaEmailDeConfirmacaoNoAuth(email);
    }else{

      this.enviaEmailDeConfirmacaoAutenticado(email);
    }
  }

  private enviaEmailDeConfirmacaoAutenticado(email: string) {

    this._auth.sendMailConfirmation(email).subscribe({
      next: (data) => {

        console.log(data);
        this.loading = false;
        this.emailEnviado = true;
      },
      error: (error) => {

        this.loading = false;
        this.emailEnviado = false;
        this.formGroupEmail.setErrors({
          emailAlreadyExists: true
        })
        console.log(error);
      }
    });
  }

  private enviaEmailDeConfirmacaoNoAuth(email: string) {

    this._auth.sendMailConfirmationNoAuth(email).subscribe({
      next: (data) => {

        this.loading = false;
        this.emailEnviado = true;
      },
      error: (error) => {

        this.loading = false;
        this.emailEnviado = false;
        this.formGroupEmail.setErrors({
          emailAlreadyExists: true
        })
        console.log(error);
      }
    });
  }

  voltar() {

    this.formGroupCode.reset();
    this.emailEnviado = false;
  }

  confirmar() {

    this.loading = true;

    this.formGroupCode.setErrors(null);

    if(this.formGroupCode.valid) {

      let code = this.formGroupCode.value.code1! + '-' + this.formGroupCode.value.code2 + '-' +this.formGroupCode.value.code3 + '-' + this.formGroupCode.value.code4;

      if( localStorage.getItem('abilities')?.includes('resetSenha') || localStorage.getItem('token') === null || localStorage.getItem('token') === '' || localStorage.getItem('token') === undefined) {

        this.confirmarNoAuth(code);
      }else{

        this.confirmarAuth(code);
      }
    }
  }

  confirmarAuth(code: string) {

    this._auth.confirmCode(code, this.formGroupEmail.value.email!).subscribe({
      next: (data: any) => {

          this.loading = false;
          console.log(data);

          if(data.redirect === 'dashboard'){

            if(this._auth.getUrlRedirect() ) {

              this._router.navigateByUrl(this._auth.getUrlRedirect());
            }else{

              this._sessions_service.redirectExternal();
            }

          }else{

              this._router.navigate([data.redirect]);
          }

        },
      error: (error) => {

        this.loading = false;
        console.log(error);
        this.formGroupCode.setErrors({
            invalidCode: true
        });
      }
    });
  }

  confirmarNoAuth(code: string) {

    this._auth.confirmResetCode(code, this.formGroupEmail.value.email!).subscribe({
      next: (data: any) => {

        this.loading = false;

          if(data.redirect === 'dashboard'){

            if(this._auth.getUrlRedirect() ) {

              this._router.navigateByUrl(this._auth.getUrlRedirect());
            }else{

              this._sessions_service.redirectExternal();
            }

          }else{

              this._router.navigate([data.redirect], { queryParams: { email: this.formGroupEmail.value.email! } });
          }
      },
      error: (error) => {

        this.loading = false;
        console.log(error);
        this.formGroupCode.setErrors({
            invalidCode: true
        });
      }
    });
  }

}
